// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-title[data-v-fc25bc3a]{width:100vw;padding:30px 0;color:#fff;background-color:#51B883;text-align:center}.main-title .desc[data-v-fc25bc3a]{margin-top:30px}.main-title .cmd[data-v-fc25bc3a]{background:#339268;color:#fff;font-family:monospace;max-width:500px;margin:30px auto 12px;border-radius:2px;padding:12px 24px;-webkit-box-sizing:border-box;box-sizing:border-box}h1[data-v-fc25bc3a],h2[data-v-fc25bc3a]{font-weight:normal}\n", ""]);
// Exports
module.exports = exports;
